import * as React from 'react';
import { INewsItem } from 'src/Entities/News/NewsItem';
import Tag, { ITagProps } from '../../Tag';

export interface INewsStatusTagProps extends ITagProps {
  item: {
    expiresAt: INewsItem['expiresAt'],
    newsLabel?: INewsItem['newsLabel'],
    [key: string]: any
  }
}

const colors = {
  default: 'gray',
  expired: 'gray',
  new: 'success',
  cancelled: 'cancelled'
};

const labels = {
  expired: 'Udløbet',
  new: 'Nyt',
  cancelled: 'Aflyst'
};

const tooltips = {
  expired: 'Denne nyhed er udløbet',
  cancelled: 'Denne nyhed er aflyst',
  new: 'Læs denne nyhed'
};

const NewsStatusTag = ({ item, ...props }: INewsStatusTagProps) => {
  const isExpired = React.useMemo(() => {
    return item.expiresAt ? item.expiresAt.valueOf() <= Date.now() : false;
  }, [item.expiresAt]);

  const status = React.useMemo(() => (isExpired ? 'expired' : item.newsLabel), [
    isExpired,
    item.newsLabel
  ]);

  const tooltip = React.useMemo(() => (status ? tooltips[status] : undefined), [
    status
  ]);

  const tag = React.useMemo(() => {
    const label = status ? labels[status] : null;
    if (!label) {
      return null;
    }

    return { label, color: colors[status || 'default'], tooltip };
  }, [status]);

  if (!tag) {
    return null;
  }
  return (
    <Tag color={tag.color} tooltip={tag.tooltip} {...props}>
      {tag.label}
    </Tag>
  );
};

export default NewsStatusTag;



// WEBPACK FOOTER //
// ./src/components/News/NewsStatusTag/index.tsx